<template>
  <div>
    <h2>{{titulo}}</h2>
    <b-row>
      <FormGroup
        cols="4"
        label="Sucursal">
        <v-select 
          @input="onChange"
          v-model="filtro.id_sucursal" 
          :clearable=false
          label="desc_sucursal"
          :options="this.$store.getters['usuario/getSucursalesFiltro']()" 
          :reduce="option=>option.id_sucursal">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Mes"> 
        <Datepicker minimum-view="month" @input="onChange" input-class="form-control" format="MM-yyyy" v-model="filtro.fecha"></Datepicker>
      </FormGroup>
      <FormGroup
        cols="4"
        :is_loading="loading"
        label="Dias perdidos"> 
        <input class="form-control" v-model="filtro.dias_perdidos">
      </FormGroup>
      <b-col v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando datos'"/></b-button>
        <b-button v-else-if="editing" variant="primary" ><Loading :size="'1'" :text="'Editando datos'"/></b-button>
        <b-button v-else variant="primary" v-on:click="guardar()">Guardar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { widgetClienteService } from '@/services';
import { utils } from '@/helpers';

export default {
  props:['titulo'],
  data(){
    return {
      utils,
      editing:false,
      loading: true,
      filtro: {
        id_sucursal:this.$store.state.usuario.sucursales.map((element) => element.id_sucursal)[0],
        fecha: new Date(new Date().getFullYear(), new Date().getMonth(),1),
        dias_perdidos:0
      },
    }
  },
  watch:{
    '$store.state.usuario.sucursales': function(){
      this.filtro.id_sucursal = this.$store.state.usuario.sucursales.map((element) => element.id_sucursal)[0];
    },
  },
  mounted(){
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      widgetClienteService.getWidgetClienteCmpcDiasPerdidos({
        id_sucursal: this.filtro.id_sucursal,
        fecha:utils.DateToFecha(this.filtro.fecha, 'dd-mm-yyyy'),
      }).then(respuesta => {
        if(respuesta.status == 'success'){
          this.filtro.dias_perdidos = respuesta.data.dias_perdidos;
        }else{
          this.filtro.dias_perdidos = 0;
        }
        this.loading = false;
      });
    },
    guardar(){
      this.editing = true;

      widgetClienteService.postWidgetClienteCmpcDiasPerdidos({
        id_sucursal: this.filtro.id_sucursal,
        fecha:utils.DateToFecha(this.filtro.fecha, 'dd-mm-yyyy'),
        dias_perdidos: this.filtro.dias_perdidos,
      }).then(respuesta => {
        utils.alerta(respuesta);
        this.editing = false;
      });
    },
    onChange(){
      this.cargarDatos();
    },
  }
}
</script>

<style scoped>
</style>
